import React from 'react';
import {FormattedHTMLMessage} from 'react-intl';
import '../css/components/min-specs.css';
require(`../assets/${process.env.PAGE}/css/components/min-specs.css`);
import RequireLoanButton from '../components/RequireLoanButton.js';

    function MinSpecs(props) {
        return (
            <div className="section dark">
                <div className="pd-main container relative">
                    <div>
                        <div className="row">
                            <div className="col-xs-offset-1 col-xs-10 col-sm-offset-0 col-sm-12 text-center">
                                <h2>Requisitos mínimos</h2>
								<h4><span>Obtené tu préstamo aprobado al instante</span></h4>
                            </div>
                        </div>
                        <div className="row faq-row">
                            <div className="col-xs-offset-1 col-xs-10 col-sm-offset-0 col-sm-12 col-md-12 faq text-center">
                                <FormattedHTMLMessage id="app.min_specs" description="min_specs"/>
                            </div>
                        </div>
                        <div className="row how_it_works__row">
                            <div className="col-xs-12 text-center">
                                <RequireLoanButton/>
                            </div>
                        </div>
                    </div>
                 </div>
            </div>
            );
    };

export default MinSpecs;


/** WEBPACK FOOTER **
 ** ./src/components/MinSpecs.js
 **/